import { RootState } from "@/app/stores"
import { postResults, toggleCampaign } from "@/shared/api/marketing-campaigns"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchToggleCampaign = createAsyncThunk<
    void,
    void,
    { state: RootState }
>('updateMarketingCampaigns/fetchToggleCampaign', async (_, thunkAPI) => {
    try {
        const { campaign } = thunkAPI.getState().updateMarketingCampaigns
        await toggleCampaign(campaign.id)
        return
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchPostResults = createAsyncThunk<
    void,
    { chatId: number },
    { state: RootState }
>('updateMarketingCampaigns/fetchToggleCampaign', async (data, thunkAPI) => {
    try {
        const { campaign } = thunkAPI.getState().updateMarketingCampaigns
        await postResults(campaign.id, data.chatId)
        return
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
